<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Name:">
              <b-form-input v-model="formFilters.name" />
            </b-form-group>
            <b-form-group label="Processing System:">
              <b-form-select
                v-model="formFilters.processingSystem"
                :options="processingSystemOptions"
              />
            </b-form-group>
            <b-form-group label="Carrier:">
              <b-v-select
                v-model="formFilters.tplCarrierId"
                :searchable="true"
                :options="tplCarriersFilterList"
              />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>
    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Carrier Integrations
            </h1>
          </div>
          <div class="col-auto">
            <router-link
              :to="{ name: 'IntegrationCarriers.Create' }"
              class="btn btn-success mr-2"
            >
              <i class="mr-2 fa fa-plus" />
              Add New
            </router-link>
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loadingItems" class="text-center p-4">
      <b-spinner variant="primary"></b-spinner>
      <p class="mt-2">Loading carriers...</p>
    </div>

    <div v-else-if="failedLoadItems" class="text-center p-4">
      <p class="text-danger">Failed to load carriers. Please try again.</p>
      <b-button variant="outline-primary" @click="loadItems()">
        <i class="fa fa-refresh mr-1"></i>
        Retry
      </b-button>
    </div>

    <div v-else>
      <div class="row" v-if="items && items.length > 0">
        <div class="col-12 col-md-6 col-lg-4" v-for="item in items" :key="item.id">
          <b-card class="mb-4" :border-variant="getCardBorderColor(item.processingSystem)">
            <template #header>
              <div class="mr-1">
                <h6 class="mb-0">{{ item.name }}</h6>
              </div>
              <div class="ml-auto">
                <b-badge :variant="getBadgeColor(item.processingSystem)">
                  {{ item.processingSystem }}
                </b-badge>
              </div>
            </template>
            <div class="card-body-content">
              <div v-if="item.description" class="mb-2">
                <small class="text-muted">{{ item.description }}</small>
              </div>
              <div v-if="item.shipEngineCarrierId" class="mb-2">
                <b>ShipEngine ID: </b> 
                <code class="small">{{ item.shipEngineCarrierId }}</code>
              </div>
              <div v-if="item.tplCarrierId" class="mb-2">
                <b>Carrier: </b> 
                <span class="text-info">{{ getTplCarrierName(item.tplCarrierId) }}</span>
              </div>
            </div>

            <template #footer>
              <div class="d-flex justify-content-between align-items-center">
                <small class="text-muted">
                  Created: {{ item.createDateTimeUtc | moment('MMM Do, YYYY') }}
                </small>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="EditItem(item)"
                >
                  <i class="fa fa-edit mr-1"></i>
                  Edit
                </b-button>
              </div>
            </template>
          </b-card>
        </div>
      </div>

      <div v-else class="text-center p-4">
        <i class="fa fa-truck fa-3x text-muted mb-3"></i>
        <h5 class="text-muted">No Carrier Integrations Found</h5>
        <p class="text-muted">Get started by adding your first integration carrier.</p>
        <router-link
          :to="{ name: 'IntegrationCarriers.Create' }"
          class="btn btn-primary"
        >
          <i class="fa fa-plus mr-2"></i>
          Add Integration Carrier
        </router-link>
      </div>

      <!-- Pagination -->
      <div v-if="items && items.length > 0 && pagination.totalPages > 1" class="d-flex justify-content-center mt-4">
        <b-pagination
          v-model="pagination.page"
          :total-rows="pagination.total"
          :per-page="pagination.perPage"
          @change="loadItems"
        ></b-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'IntegrationCarriers.Index',
  mixins: [crudMixinGen('integrationCarriers'), myCommonDataMixin],

  data: () => ({
    processingSystemOptions: [
      { value: '', text: 'All Systems' },
      { value: 'ShipEngine', text: 'ShipEngine' },
      { value: 'TechShip', text: 'TechShip' },
      { value: 'UPSDirect', text: 'UPS Direct' },
      { value: 'eHub', text: 'eHub' },
      { value: 'GlobalAccess', text: 'Global Access' },
      { value: 'Priority1', text: 'Priority 1' }
    ]
  }),

  computed: {
    tplCarriers: {
      get() {
        return this.$store.getters.getMyTPL.carriers;
      },
      set(val) {
      }
    },
    tplCarriersFilterList() {
      if (!this.tplCarriers || !this.tplCarriers.length) {
        return [{ value: '', text: 'All Carriers' }];
      }
      let filterList = [{ value: '', text: 'All Carriers' }];
      this.tplCarriers.forEach(carrier => {
        filterList.push({ 
          value: carrier.id, 
          text: carrier.name + ' (' + carrier.description + ')' 
        });
      });
      return filterList;
    }
  },

  mounted() {
    this.$store.dispatch('fetchMyTPLData');
    this.loadItems();
    this.$store.dispatch('tpl-carriers/loadItems');
  },

  methods: {
    EditItem(item) {
      this.$router.push({
        name: 'IntegrationCarriers.Edit',
        params: { id: item.id }
      });
    },

    getCardBorderColor(processingSystem) {
      const colors = {
        'ShipEngine': 'primary',
        'TechShip': 'success',
        'UPSDirect': 'warning',
        'eHub': 'info',
        'GlobalAccess': 'secondary',
        'Priority1': 'dark'
      };
      return colors[processingSystem] || 'light';
    },

    getBadgeColor(processingSystem) {
      const colors = {
        'ShipEngine': 'primary',
        'TechShip': 'success',
        'UPSDirect': 'warning',
        'eHub': 'info',
        'GlobalAccess': 'secondary',
        'Priority1': 'dark'
      };
      return colors[processingSystem] || 'light';
    },

    getTplCarrierName(tplCarrierId) {
      if (!tplCarrierId || !this.tplCarriers.length) return '';
      const carrier = this.tplCarriers.find(c => c.id === tplCarrierId);
      return carrier ? carrier.name + ' (' + carrier.description + ')' : tplCarrierId;
    }
  }
};
</script>

<style scoped>
.card-body-content {
  padding: 0;
}

.card-body-content > div {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.card-body-content > div:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
</style>